import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  equipments: [],
  total: 0,
  error: null
};

const route = "modules/manage/views/main/components/equipmentTab/redux/slice.";

export const manageSearchEquipments = createAsyncThunk(
  "manage/keyFobsTab/manageSearchEquipments",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchEquipments.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchEquipments");
      return rejectWithValue(exc);
    }
  }
);

manageSearchEquipments.query = `
        query ($conditions: [EquipmentSearchInput], $sort: [EquipmentSortInput], $limit: Int, $offset: Int) {
            data: searchEquipments(
                conditions: $conditions
                sort: $sort
                limit: $limit
                offset: $offset
            ) {
                total
                items {
                    id
                    name
                    unitsCount
                    vehicles {
                        id
                        unitId
                        unit {
                            id
                            esn
                        }
                    }
                }
            }
        }
          `;

//Slice
const manageEquipmentTabRedux = createSlice({
  name: "manageEquipmentTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchEquipments
    builder.addCase(manageSearchEquipments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchEquipments.fulfilled, (state, action) => {
      state.loading = false;
      state.equipments = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchEquipments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageEquipmentTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
